'use client';
import { createStyles } from '@s7/styles';

var useStyles = createStyles(function(theme, param) {
    var position = param.position, _spacing = param.spacing, align = param.align, offset = param.offset;
    var spacing = theme.fn.space(_spacing);
    return {
        root: {
            boxSizing: "border-box",
            display: "inline-flex",
            alignItems: align,
            gap: spacing
        },
        labelWrapper: {
            order: position === "left" ? 0 : 1,
            cursor: "pointer",
            whiteSpace: "pre-wrap",
            "&[data-disabled=true]": {
                cursor: "not-allowed",
                pointerEvents: "none"
            },
            "&[data-readonly=true]": {
                cursor: "not-allowed",
                pointerEvents: "none"
            }
        },
        inputWrapper: {
            marginTop: align && [
                "start",
                "flex-start"
            ].includes(align) ? "" + offset + "px" : undefined,
            marginBottom: align && [
                "end",
                "end-start"
            ].includes(align) ? "" + offset + "px" : undefined
        }
    };
});

export { useStyles as default };
